const StoreDatas = [
    { 
        id : 1 ,
        img : 'https://i.ibb.co/crLJbFq/store1.png',
        title : 'Experience Design',
        description : 'The point of using Lorem Ipsum is that it has a more -or-less normal.'
    },
    { 
        id : 2 ,
        img : 'https://i.ibb.co/jWNt3qN/store2.png',
        title : 'Interface Design',
        description : 'The point of using Lorem Ipsum is that it has a more -or-less normal.'
    },
    { 
        id : 3 ,
        img : 'https://i.ibb.co/5LSCH3f/store3.png',
        title : 'Prototyping',
        description : 'The point of using Lorem Ipsum is that it has a more -or-less normal.'
    },
    { 
        id : 4 ,
        img : 'https://i.ibb.co/tQskZ8S/store4.png',
        title : 'Illustration',
        description : 'The point of using Lorem Ipsum is that it has a more -or-less normal.'
    }
    
]

export default StoreDatas;